<template>
  <ion-page>
    <ion-content scroll-y="false" :fullscreen="true">
      <div id="container">
        <ion-list lines="full" class="ion-no-margin">
          <ion-list-header lines="full">
            <ion-label>
              <h1>Lets Have Coffee</h1>
              <br />
              <br />
              <h2>
                Meet new people and talk about common Hobbies and Interests
              </h2>
            </ion-label>
          </ion-list-header>
          <br />
          <ion-item>
            <ion-label>Email Address</ion-label>
            <ion-input
              v-model="usr"
              placeholder="Email Address"
              type="text"
            ></ion-input>
          </ion-item>

          <ion-item>
            <ion-label>Password</ion-label>
            <ion-input
              v-model="pwd"
              placeholder="Password"
              type="password"
            ></ion-input>
          </ion-item>
        </ion-list>
        <br />
        {{ state }}
        <br />
        <ion-button @click="login()">Login</ion-button>
        <br />
        <br />
        <ion-button @click="newUser()">New User</ion-button>
        <br />
        <ion-button @click="forgotPassword()">Forgot Password</ion-button>
        <br />
        <ion-checkbox v-model="termsChecked" /> I agree to the
        <ion-button @click="tAndCs()">Terms and Conditions</ion-button>
        <br />
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonContent,
  IonPage,
  IonList,
  IonListHeader,
  IonLabel,
  IonInput,
  IonItem,
  IonButton,
  IonCheckbox,
} from "@ionic/vue";
import router from "../router";
import api from "../network";
import { defineComponent } from "vue";
import { bus } from "../main";

export default defineComponent({
  name: "Login",
  components: {
    IonContent,
    IonPage,
    IonList,
    IonListHeader,
    IonLabel,
    IonInput,
    IonItem,
    IonButton,
    IonCheckbox,
  },
  data() {
    return {
      usr: "" as string,
      pwd: "" as string,
      state: "" as string,
      termsChecked: false,
    };
  },
  methods: {
    login(): void {
      if (this.termsChecked !== true) {
        bus.emit("toastMessage", {
          message: "Please Read and Agree to the Terms and Condtions",
          isError: true,
        });
        return;
      }
      this.state = "Logging In...";
      api
        .login(this.usr, this.pwd)
        .then(() => {
          const msg = "Logged in";
          this.state = msg;
          bus.emit("toastMessage", { message: msg });

          router.push("/chats");
          location.reload();
        })
        .catch((err) => {
          const errmsg = "" + err;
          this.state = errmsg;
          bus.emit("toastMessage", { message: errmsg, isError: true });
        });
    },
    newUser() {
      if (this.termsChecked !== true) {
        bus.emit("toastMessage", {
          message: "Please Read and Agree to the Terms and Condtions",
          isError: true,
        });
        return;
      }
      router.push("/register");
    },
    tAndCs() {
      router.push("/terms");
    },
    forgotPassword() {
      router.push("/resetpassword");
    },
  },
});
</script>

<style scoped>
ion-menu-button {
  color: var(--ion-color-primary);
}

#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
</style>